import React from 'react'
import { isEmpty } from 'ramda'
import { Card, CardItem } from '../../../../../../components/Card'
import Divider from '../../../../../../components/Divider'
import Buttons from '../../../../../../modules/Buttons'
import Button from '../../../../../../components/inputs/Button'
import ExpansionPanel from '../../../../../../components/ExpansionPanel'
import Table from '../../../../../../components/Table'
import Modal from '../../../../../../components/Modal'
import FormAddBiosensor from './components/FormAddBiosensor'
import FormRemoveBiosensor from './components/FormRemoveBiosensor'
import Icon from '../../../../../../components/Icon';

const Biosensors = ({ cowid, biosensors, refetchCow }) => {
    return (
        biosensors &&
        <>
            <Card>
                <CardItem
                    left={{
                        name: biosensors.ear.title,
                        value: biosensors.ear.info
                    }}
                    right={<Icon name={biosensors.ear['row_id'] ? 'icon_tick' : 'icon_untick'} />}
                />
                <Divider />
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Buttons>
                                <Button
                                    onClick={handleToggleIsOpenModal}
                                    fullWidth
                                    green
                                >
                                    {biosensors.ear.label}
                                </Button>
                            </Buttons>
                        )
                    }
                >
                    {
                        biosensors.ear.row_id ?
                            ({ handleToggleIsOpenModal }) => (
                                <FormRemoveBiosensor
                                    cowid={cowid}
                                    header={biosensors.ear['modal']['form-label']}
                                    biosensor={{
                                        name: 'ear',
                                        serial: biosensors.ear.row_id
                                    }}
                                    buttons={{
                                        submit: biosensors.ear['modal'].buttons.save,
                                        cancel: biosensors.ear['modal'].buttons.cancel
                                    }}
                                    onClickCancel={handleToggleIsOpenModal}
                                    refetchCow={refetchCow}
                                />
                            ) :
                            ({ handleToggleIsOpenModal }) => (
                                <>
                                    <CardItem
                                        left={{
                                            name: biosensors.ear.title,
                                            value: biosensors.ear.info
                                        }}
                                        right={<Icon name={biosensors.ear['row_id'] ? 'icon_tick' : 'icon_untick'} />}
                                    />
                                    <Divider />
                                    <FormAddBiosensor
                                        cowid={cowid}
                                        biosensor={{
                                            name: 'ear'
                                        }}
                                        endpoint={biosensors.ear['modal']['endpoint']}
                                        onClickCancel={handleToggleIsOpenModal}
                                        refetchCow={refetchCow}
                                    />
                                    <ExpansionPanel
                                        title={biosensors.ear.footer}
                                    >
                                        {
                                            !isEmpty(biosensors.ear.history.data) ?
                                                <Table
                                                    columns={[{
                                                        name: biosensors.ear.history.label.from,
                                                        key: 'from'
                                                    }, {
                                                        name: biosensors.ear.history.label.to,
                                                        key: 'to'
                                                    }, {
                                                        name: biosensors.ear.history.label.serial,
                                                        key: 'serial'
                                                    }]}
                                                    data={biosensors.ear.history.data}
                                                />
                                                :
                                                biosensors.ear.history.info
                                        }
                                    </ExpansionPanel>
                                </>
                            )
                    }
                </Modal>
                <ExpansionPanel
                    title={biosensors.ear.footer}
                >
                    {
                        !isEmpty(biosensors.ear.history.data) ?
                            <Table
                                columns={[{
                                    name: biosensors.ear.history.label.from,
                                    key: 'from'
                                }, {
                                    name: biosensors.ear.history.label.to,
                                    key: 'to'
                                }, {
                                    name: biosensors.ear.history.label.serial,
                                    key: 'serial'
                                }]}
                                data={biosensors.ear.history.data}
                            />
                            :
                            biosensors.ear.history.info
                    }
                </ExpansionPanel>
            </Card>
            <Card>
                <CardItem
                    left={{
                        name: biosensors.tail.title,
                        value: biosensors.tail.info
                    }}
                    right={<Icon name={biosensors.tail['row_id'] ? 'icon_tick' : 'icon_untick'} />}
                />
                <Divider />
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Buttons>
                                <Button
                                    onClick={handleToggleIsOpenModal}
                                    fullWidth
                                    green
                                >
                                    {biosensors.tail.label}
                                </Button>
                            </Buttons>
                        )
                    }
                >
                    {
                        biosensors.tail.row_id ?
                            ({ handleToggleIsOpenModal }) => (
                                <FormRemoveBiosensor
                                    cowid={cowid}
                                    header={biosensors.tail['modal']['form-label']}
                                    biosensor={{
                                        name: 'tail',
                                        serial: biosensors.tail.row_id
                                    }}
                                    buttons={{
                                        submit: biosensors.tail['modal'].buttons.save,
                                        cancel: biosensors.tail['modal'].buttons.cancel
                                    }}
                                    onClickCancel={handleToggleIsOpenModal}
                                    refetchCow={refetchCow}
                                />
                            ) :
                            ({ handleToggleIsOpenModal }) => (
                                <>
                                    <CardItem
                                        left={{
                                            name: biosensors.tail.title,
                                            value: biosensors.tail.info
                                        }}
                                        right={<Icon name={biosensors.tail['row_id'] ? 'icon_tick' : 'icon_untick'} />}
                                    />
                                    <Divider />
                                    <FormAddBiosensor
                                        cowid={cowid}
                                        biosensor={{
                                            name: 'tail'
                                        }}
                                        endpoint={biosensors.tail['modal']['endpoint']}
                                        onClickCancel={handleToggleIsOpenModal}
                                        refetchCow={refetchCow}
                                    />
                                    <ExpansionPanel
                                        title={biosensors.tail.footer}
                                    >
                                        {
                                            !isEmpty(biosensors.tail.history.data) ?
                                                <Table
                                                    columns={[{
                                                        name: biosensors.tail.history.label.from,
                                                        key: 'from'
                                                    }, {
                                                        name: biosensors.tail.history.label.to,
                                                        key: 'to'
                                                    }, {
                                                        name: biosensors.tail.history.label.serial,
                                                        key: 'serial'
                                                    }]}
                                                    data={biosensors.tail.history.data}
                                                />
                                                :
                                                biosensors.tail.history.info
                                        }
                                    </ExpansionPanel>
                                </>
                            )
                    }
                </Modal>
                <ExpansionPanel
                    title={biosensors.tail.footer}
                >
                    {
                        !isEmpty(biosensors.tail.history.data) ?
                            <Table
                                columns={[{
                                    name: biosensors.tail.history.label.from,
                                    key: 'from'
                                }, {
                                    name: biosensors.tail.history.label.to,
                                    key: 'to'
                                }, {
                                    name: biosensors.tail.history.label.serial,
                                    key: 'serial'
                                }]}
                                data={biosensors.tail.history.data}
                            />
                            :
                            biosensors.tail.history.info
                    }
                </ExpansionPanel>
            </Card>
        </>
    )
}

export default Biosensors